import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";
import Index from "./pages/Index";
import WhySons from "./pages/WhySons";
import Cabanas from "./pages/Cabanas";
import Tubing from "./pages/Tubing";
import Glamping from "./pages/Glamping";
import PropertyMap from "./pages/PropertyMap";
import FAQs from "./pages/FAQs";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CancellationPolicy from "./pages/CancellationPolicy";
import NotFound from "./pages/NotFound";
import BookNow from "./pages/BookNow";
import BookGeronimo from "./pages/BookGeronimo";
import BookRiverRanch from "./pages/BookRiverRanch";
import BookRiverRanchOvernight from "./pages/BookRiverRanchOvernight";
import BookBlueRiverCamp from "./pages/BookBlueRiverCamp";
import BookBlueRiverCampOvernight from "./pages/BookBlueRiverCampOvernight";
import BookRioCibolo from "./pages/BookRioCibolo";
import BookRioCiboloOvernight from "./pages/BookRioCiboloOvernight";
import BookSonsIsland from "./pages/BookSonsIsland";
import BookSonsGuadalupe from "./pages/BookSonsGuadalupe";
import BookSonsGuadalupeOvernight from "./pages/BookSonsGuadalupeOvernight";
import BookSonsIslandOvernight from "./pages/BookSonsIslandOvernight";
import Waivers from "./pages/Waivers";
import ThankYou from "./pages/ThankYou";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/why-sons" element={<WhySons />} />
          <Route path="/cabanas" element={<Cabanas />} />
          <Route path="/tubing" element={<Tubing />} />
          <Route path="/glamping" element={<Glamping />} />
          <Route path="/property-map" element={<PropertyMap />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cancellation" element={<CancellationPolicy />} />
          <Route path="/book-now" element={<BookNow />} />
          <Route path="/book-now/geronimo" element={<BookGeronimo />} />
          <Route path="/book-now/river-ranch" element={<BookRiverRanch />} />
          <Route path="/book-now/river-ranch-overnight" element={<BookRiverRanchOvernight />} />
          <Route path="/book-now/blue-river-camp" element={<BookBlueRiverCamp />} />
          <Route path="/book-now/blue-river-camp-overnight" element={<BookBlueRiverCampOvernight />} />
          <Route path="/book-now/rio-cibolo" element={<BookRioCibolo />} />
          <Route path="/book-now/rio-cibolo-overnight" element={<BookRioCiboloOvernight />} />
          <Route path="/book-now/sons-island" element={<BookSonsIsland />} />
          <Route path="/book-now/sons-island-overnight" element={<BookSonsIslandOvernight />} />
          <Route path="/book-now/sons-guadalupe" element={<BookSonsGuadalupe />} />
          <Route path="/book-now/sons-guadalupe-overnight" element={<BookSonsGuadalupeOvernight />} />
          <Route path="/waivers" element={<Waivers />} />
          <Route path="/thankyou" element={<ThankYou />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
